
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("vszuE", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=pt-BR.5d81731a.js.map
